function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M10.8657 0.153809C11.6816 0.153809 12.3431 0.816772 12.3431 1.63458V18.7905L18.6855 12.4337C19.2624 11.8554 20.1979 11.8554 20.7748 12.4337C21.3518 13.0119 21.3518 13.9495 20.7748 14.5278L11.9104 23.4124C11.3334 23.9907 10.398 23.9907 9.821 23.4124L0.956528 14.5278C0.379562 13.9495 0.379562 13.0119 0.956528 12.4337C1.53349 11.8554 2.46894 11.8554 3.0459 12.4337L9.38827 18.7905V1.63458C9.38827 0.816772 10.0497 0.153809 10.8657 0.153809Z",
  fill: "white"
});

var SvgScrollArrow = function SvgScrollArrow(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgScrollArrow, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/scrollArrow.6ef6d961.svg";
export { ForwardRef as ReactComponent };